import styled from '@emotion/styled';
import { Modal } from 'antd';
import { type CSSProperties, type FC, type MouseEvent, type ReactNode, useState } from 'react';
import { IconQuestionOutline } from '../BasicComponents/Icons';
import { sizeToWidth } from './sizeToWidth';

interface HelperModalProps {
  title?: ReactNode;
  children?: ReactNode;
  style?: CSSProperties;
  size?: 'sm' | 'lg' | 'xl';
}

const HintWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  transform: translateY(-2px);
`;

export const HelperModal: FC<HelperModalProps> = ({ title, children, style, size }) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <HintWrapper>
        <IconQuestionOutline
          className="hint"
          style={{ cursor: 'pointer', ...style }}
          onClick={handleClick}
        />
      </HintWrapper>
      <Modal
        title={title}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={sizeToWidth[size ?? 'sm']}
      >
        {children}
      </Modal>
    </>
  );
};
